export default __webpack_public_path__ + "static/screenshot6-9e61d0a43150cba525f36d94ef41e26c.jpg";